// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3u3ntupjGuqPLK1wBIv1-B {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 300px;\n    padding: 0 20px 32px 20px;\n}\n\n._3AhakrRlkhxMsXcRswlvZg {\n    display: flex;\n    justify-content: space-between;\n    float: right;\n}\n\n._33LG2sgOm1p7rUeoEpaH3K {\n    align-self: center;\n}\n\n._2VZgAtjGuK_fvqCZyKw3Zh {\n    font-size: 16px;\n    line-height: 1.8;\n}\n\n._2Ieqw38ps3nW9aFahX5XIB {\n    color: hsl(0, 0%, 50%);\n    font-size: 12px;\n}\n\n._2F5xorgVTw_nqqBBmFdQTY {\n    display: flex;\n    flex: 1;\n}\n\n.mFFzecesrkF2uhjI3gvOY {\n    margin: 36px auto;\n    text-align: center;\n}", ""]);
// Exports
exports.locals = {
	"page": "_3u3ntupjGuqPLK1wBIv1-B",
	"header": "_3AhakrRlkhxMsXcRswlvZg",
	"select": "_33LG2sgOm1p7rUeoEpaH3K",
	"heading": "_2VZgAtjGuK_fvqCZyKw3Zh",
	"subheading": "_2Ieqw38ps3nW9aFahX5XIB",
	"content": "_2F5xorgVTw_nqqBBmFdQTY",
	"loading": "mFFzecesrkF2uhjI3gvOY"
};
module.exports = exports;
